import { checkboxImg } from '../../../../../../../../../theme/images';
import { StubbornToolboxProperties } from '../../../../../../../../business/StubbornToolboxMapping';

export const toolbox: StubbornToolboxProperties = {
  name: 'checkbox',
  label: 'Checkbox',
  category: 'Inputs',
  image: checkboxImg,
};
